import React, { CSSProperties, FC } from 'react';
import classNames from 'classnames';

import lang from '../../../lib/language';

import IconNotSubscriber from '../../../assets/bigImages/capital_welcome_subscriber.png';
import IconCloseWhite from '../../../assets/img/icon-close-white.svg';
import { useIsMobile } from '../../../hooks';
import { ButtonTypesEnum } from '../../Button/Button.types';
import { BaseModal, Button, ClickableImage } from '../../index';

import styles from './TournamentEndingInfoModal.module.scss';

type Props = { setIsDisplayModal: (status: boolean) => void };

const TournamentEndingInfoModal: FC<Props> = (props: Props): JSX.Element => {
  const { setIsDisplayModal } = props;
  const isMobile = useIsMobile();

  const getMarginTop = () :number => {
    if (window.innerHeight < 540) {
      return window.innerHeight / 16;
    }

    if (window.innerHeight < 600) {
      return window.innerHeight / 8;
    }

    if (window.innerHeight < 700) {
      return window.innerHeight / 6;
    }

    if (window.innerHeight < 900) {
      return window.innerHeight / 4;
    }

    return window.innerHeight / 3.8;
  };

  const modalStyle: CSSProperties = isMobile
    ? {
      paddingBottom: 0,
      margin: 0,
      marginTop: getMarginTop(),
      width: window.innerWidth,
      position: 'fixed',
      alignSelf: 'flex-end',
    }
    : {};

  return (
    <BaseModal customStyle={modalStyle} className={styles.modal} isOpen unmountOnClose>
      <div className={styles.content}>
        {isMobile && <ClickableImage alt="" src={IconCloseWhite} className={styles.closeIcon} onClick={() => setIsDisplayModal(false)} />}
        <img src={IconNotSubscriber} className={classNames(styles.image)} alt="" />
        <div className={styles.title}>{lang.commonTournamentEndAppoaching()}</div>
        <span className={styles.descriptipon}>{lang.commonTournamentEndAppoachingDesc()}</span>
      </div>
      <Button
        className={classNames(styles.button, { [styles.buttonMob]: isMobile })}
        variant={ButtonTypesEnum.Primary}
        onClick={() => setIsDisplayModal(false)}
      >
        {lang.commonClose()}
      </Button>
    </BaseModal>
  );
};

export default TournamentEndingInfoModal;
